__webpack_require__.p = "/wool/";